if(!customElements.get('site-image')) {
  class SiteImage extends HTMLElement {
    constructor() {
      super();
      this.observe();
    }

    observe() {
      if ("IntersectionObserver" in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(function (image) {
            const $image = image.target;
            if (image.isIntersecting) {
              $image.classList.add("active");
              imageObserver.unobserve($image);
            }
          });
        });

        imageObserver.observe(this.querySelector(".mediabox"));
      }
    }
  }

  customElements.define("site-image", SiteImage);
}
